export const yamlBasicIndentation = '  ';
